import present from "present"

const speedtest = new class Speedtest {
    constructor() {
        this.results = {}
    }
    report(collection) {
        if(this.results[collection] == undefined) {
            console.log("Could not find collection", collection)
            return
        }
        console.table(
            Object.values(this.results[collection]).map((result) => {
                return {
                    "Key": result.key,
                    "Total Duration": result.totalDuration,
                    "Average Duration": result.averageDuration,
                    "Count": result.count,
                }
            })
        )
    }
    mark(collection, key) {
        const startTime = present()
        return () => {
            const endTime = present()
            const duration = endTime - startTime

            if(this.results[collection] == undefined) {
                this.results[collection] = {}
            }

            if(this.results[collection][key] == undefined) {
                this.results[collection][key] = {
                    "key": key,
                    "totalDuration": 0,
                    "count": 0,
                }
            }

            const results = this.results[collection][key]

            results.count += 1
            results.totalDuration += duration
            results.averageDuration = results.totalDuration / results.count

            let label = ""
            if(collection != undefined) {
                label += collection
            }
            if(key != undefined) {
                label += ":" + key
            }
            if(label == "") {
                label = "Speedtest"
            }
            return {
                "duration": duration,
                "log": (options = {}) => {
                    const maximum = options.maximum || Infinity
                    const message = label + " ran for " + duration.toFixed(2) + "ms"
                    if(duration > maximum) {
                        console.log("%c" + message, "color:red")
                    } else {
                        console.log(message)
                    }
                }
            }
        }
    }
    markwrap(collection, key, func) {
        let unmark = this.mark(collection, key)
        func()
        unmark()
    }
}

export default speedtest

if(typeof window != "undefined") {
    window.frog = window.frog || {}
    window.frog.speedtests = speedtest
}
